import { render, staticRenderFns } from "./ComShopList.vue?vue&type=template&id=823b45f2&scoped=true&"
import script from "./ComShopList.vue?vue&type=script&lang=js&"
export * from "./ComShopList.vue?vue&type=script&lang=js&"
import style0 from "./ComShopList.vue?vue&type=style&index=0&id=823b45f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823b45f2",
  null
  
)

export default component.exports